export const normalizeDescription = (description = "") => {
  if (!description) {
    return "";
  }
  return description.replace(/(\\n)/g, "\n").trim();
};
